module.exports = __webpack_public_path__ + "media/images/faces/male/31-1358ed2a4c089eee1278eb4dafdc54af.jpg";